<div class="rectangle-container denture-details-info">
    <div class="rx-app-flex-container-column">
        <div class="denture-details-info__title">
            {{ 'DentureDetails.SectionTitle' | translate }}
        </div>
        <div class="general-info-body rx-app-flex-container-row" [class.denture-details-info__body]="isResponsive">
            <div class="info-box rx-app-flex rx-app-flex-container-column">
                <div class="fields-container rx-app-flex-container-column rx-app-flex-container-column--justify-space-between">
                    <div class="field" id="denture-print-stage">
                        <div class="field-name">
                            {{ 'DentureDetails.StageTitle' | translate }}:
                        </div>
                        <div class="field-info">{{ stage | doubleHyphen }}</div>
                    </div>
                </div>
                <div class="fields-container denture-details-info__selectors-container rx-app-flex-container-column">
                    <div class="field">
                        <div class="field-name rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--align-center" id="denture-print-upperDenture">
                            {{ 'DentureDetails.UpperDentureTitle' | translate }}:
                            <img class="denture-details-info__selector"
                                [src]="isUpperJawChecked | mapper : getSrcForRadioButtonImg" alt="checked">
                        </div>
                    </div>
                    <div class="field">
                        <div class="field-name rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--align-center" id="denture-print-lowerDenture">
                            {{ 'DentureDetails.LowerDentureTitle' | translate }}:
                            <img class="denture-details-info__selector"
                                [src]="isLowerJawChecked | mapper : getSrcForRadioButtonImg" alt="checked">
                        </div>
                    </div>
                </div>
            </div>
            <div class="rx-separator vertical" [class.denture-details-info__separator]="isResponsive"></div>
            <div class="info-box rx-app-flex rx-app-flex-container-column">
                <div class="fields-container rx-app-flex-container-column rx-app-flex-container-column--justify-space-between">
                    <div class="field rx-app-flex rx-app-flex-container-row" id="denture-print-mould">
                        <div>
                            <div class="field-name">
                                {{ 'DentureDetails.MouldTitle' | translate }}:
                            </div>
                            <div class="field-info">{{ mould?.Name | doubleHyphen }}</div>
                        </div>
                        <rx-mould-element *ngIf="mould" class="denture-details-info__mould-image" [mould]="mould" [showName]="false"></rx-mould-element>
                    </div>
                </div>
                <div class="fields-container rx-app-flex-container-column">
                    <div class="field" id="denture-print-gingival">
                        <div class="field-name">
                            {{ 'DentureDetails.GingivalShadeTitle' | translate }}:
                        </div>
                        <div class="field-info">{{gingivalShade | doubleHyphen}}</div>
                    </div>
                </div>
            </div>
            <div class="rx-separator vertical" [class.denture-details-info__separator]="isResponsive"></div>
            <div class="rx-app-flex rx-app-flex-container-column">
                <rx-info-block class="info-box rx-app-flex rx-app-flex-container-column" [fields]="[
                            { name: 'DentureDetails.ShadeSystemTitle', value: shadeSystem, id: 'denture-print-shadeSystem' },
                            { name: 'DentureDetails.TeethShadeTitle', value: teethShade, id: 'denture-print-teethShade'}
                        ]"></rx-info-block>
            </div>
        </div>
    </div>
</div>
